import React from "react";
import { Stack } from "@mui/material";

import { HubSideBar } from "../../components";

import BarcodeSettings from "./BarcodeSettings";
import BarcodeValue from "./BarcodeValue";
import { BarcodeDetails } from "./BarcodeDetails";
import BarcodePageSettings from "./BarcodePageSettings";

export const BarcodeEditorSideBar = ({ disabled = false, disableType }) => {
  return (
    <HubSideBar position="right" maxWidth="500px" sx={{ padding: "25px 15px" }}>
      <Stack width="100%" gap="15px">
        <BarcodeSettings disabled={disabled} disableType={disableType} />
        <BarcodeValue disabled={disabled} />
        <BarcodeDetails disabled={disabled} />
        <BarcodePageSettings disabled={disabled} />
      </Stack>
    </HubSideBar>
  );
};

export default BarcodeEditorSideBar;
